import { mergeCustomJewelryConfig } from '../content/siteCopyHelpers';

export { CUSTOM_JEWELRY_DEFAULTS } from './customJewelryDefaults';

export function getCustomJewelryConfig(storeCopy) {
  return mergeCustomJewelryConfig(storeCopy?.custom_jewelry);
}

export function isCustomJewelryEnabled(storeCopy) {
  return getCustomJewelryConfig(storeCopy).enabled !== false;
}

/** Top-level header link (alongside Exhibitions). */
export function isCustomJewelryMainNavVisible(storeCopy) {
  const cfg = getCustomJewelryConfig(storeCopy);
  return cfg.enabled !== false && cfg.show_in_main_nav !== false;
}

export function getVisibleDesignGallery(storeCopy) {
  const cfg = getCustomJewelryConfig(storeCopy);
  if (cfg.design_gallery_enabled === false) return [];
  const items = Array.isArray(cfg.design_gallery) ? cfg.design_gallery : [];
  return items.filter((item) => item && item.enabled !== false && String(item.image || '').trim());
}

/** Up to 4 hero mosaic paths (falls back to legacy single hero_image). */
export function resolveCustomJewelryHeroImages(copy) {
  const cfg = copy && typeof copy === 'object' ? copy : {};
  const fromArray = Array.isArray(cfg.hero_images)
    ? cfg.hero_images.map((v) => String(v || '').trim()).filter(Boolean)
    : [];
  if (fromArray.length) return fromArray.slice(0, 4);
  const single = String(cfg.hero_image || '').trim();
  return single ? [single] : [];
}

/** Label for top-level header link (keep short — e.g. Bespoke). */
export function customJewelryMainNavLabel(storeCopy) {
  const cfg = getCustomJewelryConfig(storeCopy);
  const main = String(cfg.main_nav_label || '').trim();
  if (main) return main;
  return cfg.nav_label || 'Custom';
}

/** @param {'shop'|'nav'|'footer'|'card'|'gift_finder'} placement */
export function isCustomJewelryLinkVisible(storeCopy, placement) {
  const cfg = getCustomJewelryConfig(storeCopy);
  if (!cfg.enabled) return false;
  switch (placement) {
    case 'shop':
      return cfg.show_on_shop !== false;
    case 'nav':
      return cfg.show_in_nav !== false;
    case 'footer':
      return cfg.show_in_footer !== false;
    case 'gift_finder':
      return cfg.show_on_gift_finder !== false;
    default:
      return false;
  }
}

/** @param {'shop'|'nav'|'footer'|'card'} placement */
export function customJewelryLinkLabel(storeCopy, placement = 'shop') {
  const cfg = getCustomJewelryConfig(storeCopy);
  if (placement === 'nav' || placement === 'footer') return cfg.nav_label;
  return cfg.shop_button_label;
}
